import { PortalDsBadge } from 'src/components/portal-design-system';
import { resolveWorkspaceMemberCounts } from '../utils/portal-users.mappers';
import type { PortalWorkspaceSummary } from '../types/users.types';

interface MemberStatusBreakdownCellProps {
  workspace: Pick<PortalWorkspaceSummary, 'member_count' | 'active_member_count' | 'blocked_member_count'>;
}

export function MemberStatusBreakdownCell({ workspace }: MemberStatusBreakdownCellProps) {
  const { active, blocked } = resolveWorkspaceMemberCounts(workspace);

  return (
    <div className="flex flex-wrap items-center gap-2">
      <PortalDsBadge variant="green" pill>
        {active}
        {' '}
        active
      </PortalDsBadge>
      {blocked > 0 ? (
        <PortalDsBadge variant="red" pill>
          {blocked}
          {' '}
          blocked
        </PortalDsBadge>
      ) : (
        <span className="text-[12px] text-[#9CA3AF]">
          0 blocked
        </span>
      )}
    </div>
  );
}
